import { ImageValidator } from '~/validators'

export default {
  props: {
    image_desktop: {
      type: Object,
      validator: prop => ImageValidator(prop, 'image_desktop'),
    },

    image_tablet: {
      type: Object,
      validator: prop => ImageValidator(prop, 'image_tablet'),
    },

    image_mobile: {
      type: Object,
      validator: prop => ImageValidator(prop, 'image_mobile'),
    },

    overlap: {
      type: Boolean,
    },

    transparent: {
      type: Boolean,
    },
  },

  computed: {
    placeholderClasses() {
      const classes = []

      if (this.hasImagePlaceholder) classes.push('hero--placeholder-image')
      if (this.hasImagePlaceholder && this.hasOverlappedImagePlaceholer) classes.push('hero--placeholder-image-overlap')
      if (this.hasVideoPlaceholder) classes.push('hero--placeholder-video')

      return classes
    },

    hasImagePlaceholder() {
      return !!this.image_desktop || !!this.image_tablet || this.image_mobile
    },

    hasOverlappedImagePlaceholer() {
      return !!this.overlap
    },

    placeholder() {
      return {
        src: this.image_desktop ? this.image_desktop.url : '',
        srcsetTablet: this.image_tablet ? this.image_tablet.url : '',
        srcsetMobile: this.image_mobile ? this.image_mobile.url : '',
        alt: this.alt,
        overlap: this.overlap,
        transparent: this.transparent,
        aspectRatio: '1:1',
      }
    },
  },
}
